import { render } from "./index.vue?vue&type=template&id=a24d56d4&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=a24d56d4&scoped=true&lang=less"

import exportComponent from "/home/runner/work/smanga/smanga/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a24d56d4"],['__file',"src/views/bookmark-setting/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a24d56d4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a24d56d4', __exports__)) {
    console.log('reload')
    api.reload('a24d56d4', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=a24d56d4&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('a24d56d4', render)
  })

}


export default __exports__